import { render, staticRenderFns } from "./ProductsGroupHeader.vue?vue&type=template&id=90f9f2f4&scoped=true&"
import script from "./ProductsGroupHeader.vue?vue&type=script&lang=js&"
export * from "./ProductsGroupHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductsGroupHeader.vue?vue&type=style&index=0&id=90f9f2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f9f2f4",
  null
  
)

export default component.exports